export default __webpack_public_path__ + "static/media/service-request.eede5602.svg";